module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi",
      "title": "xi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Foreword")])]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" by Cami Andersen  ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-3"
  }, [_c('span', {
    staticClass: "med"
  }, [_vm._v("Chapter 1:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Weird Herb")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 2:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("The Predator")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 3:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 4:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Too Good to Be True")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 5:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Haunted")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 6:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Pursued")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 7:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Attacked")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 8:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Herb Did It")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 9:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Boots on the Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 10:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Showdown")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 11:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Into the Pool")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 12:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Welcome Back")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 13:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Mixing It Up")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 14:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("A Truly Sick Man")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 15:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("The One That Got Away")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 16:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Get Away from There")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-4"
  }, [_c('span', {
    staticClass: "med CharOverride-1"
  }, [_vm._v("Chapter 17:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Stay Away")])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/HFHF19#_idParaDest-24"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Conclusion: Making Sense of It All")])]), _c('span', {
    staticClass: "ital"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/HFHF20#_idParaDest-25"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/HFHF20a#_idParaDest-26"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Acknowledgments")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0